(function () {
    'use strict';

    angular.module('sempraWebapp').factory('transactionsActions', transactionsActionsFactory);

    /** @ngInject */
    function transactionsActionsFactory(api, $q) {
        return {
            getTransactionsExpenses: getTransactionsExpenses,
            getTransactionsTopUps : getTransactionsTopUps
        };

        function getTransactionsExpenses(email, from, to, page, pageSize, orderBy, order) {
            var deferred = $q.defer();
            api.getTransactionsExpenses(email, from, to, page, pageSize, orderBy, order).then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }

        function getTransactionsTopUps(email, from, to, page, pageSize, orderBy, order) {
            var deferred = $q.defer();
            api.getTransactionsTopUps(email, from, to, page, pageSize, orderBy, order).then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }

    }
})();
